import { IPmListFilterExtraField } from '../interfaces/IPmListFilterExtraField';

export const initialPmListAdditionalFields: IPmListFilterExtraField[] = [
  {
    id: 'supervisionType',
    name: 'Вид государственного контроля (надзора)',
    isSelected: false,
    type: 'select',
    isSearchable: true,
    isClearable: true,
  },
  {
    id: 'startDateBetween',
    name: 'Дата начала проведения ПМ (интервал)',
    isSelected: false,
    type: 'date',
  },
  {
    id: 'hasObjectionWarning',
    name: 'Сведения о направлении возражения на предостережение',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'reasons',
    name: 'Основание проведения ПМ',
    isSelected: false,
    isSearchable: true,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'subjectTypes',
    name: 'Тип проверяемого лица',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'subjectOrgName',
    name: 'Наименование проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectOgrn',
    name: 'ОГРН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectInn',
    name: 'ИНН проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectKpp',
    name: 'КПП проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectOkveds',
    name: 'Код ОКВЭД проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectSnils',
    name: 'СНИЛС проверяемого лица',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'subjectCountries',
    name: 'Страна проверяемого лица',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectAddress',
    name: 'Местонахождение объекта',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'objectTypes',
    name: 'Тип объекта проверки',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectKinds',
    name: 'Вид объекта проверки',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectSubKinds',
    name: 'Подвид объекта проверки',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'objectRiskCategory',
    name: 'Категория риска',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'objectDangerClass',
    name: 'Класс опасности',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'isHasCollaboratingOrganization',
    name: 'Проводится совместно',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'inspectorFullName',
    name: 'ФИО должностного лица контрольных (надзорных) органов, участвующих в соответствующих ПМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'signed',
    name: 'Статус подписания',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'statuses',
    name: 'Статус ПМ',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'pubStatuses',
    name: 'Статус публикации',
    isSelected: false,
    type: 'select',
    isMulti: true,
  },
  {
    id: 'erpId',
    name: 'Учетный номер ПМ',
    isSelected: false,
    type: 'text',
  },
  {
    id: 'deletedInclude',
    name: 'Показывать удаленные ПМ',
    isSelected: false,
    type: 'select',
  },
  {
    id: 'deletedOnly',
    name: 'Показывать только удаленные ПМ',
    isSelected: false,
    type: 'select',
  },
];

export const isTestAdditionalField: IPmListFilterExtraField = {
  id: 'isTest',
  name: 'Тестовый',
  isSelected: false,
  type: 'select',
};
